import { render, staticRenderFns } from "./dataAnalysis.vue?vue&type=template&id=1d4d1bf3&scoped=true&"
import script from "./dataAnalysis.vue?vue&type=script&lang=js&"
export * from "./dataAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./dataAnalysis.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dataAnalysis.vue?vue&type=style&index=1&id=1d4d1bf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4d1bf3",
  null
  
)

export default component.exports